import { render, staticRenderFns } from "./mappingList.vue?vue&type=template&id=d8daab06"
import script from "./mappingList.vue?vue&type=script&lang=js"
export * from "./mappingList.vue?vue&type=script&lang=js"
import style0 from "./mappingList.vue?vue&type=style&index=0&id=d8daab06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_35e1b9026555e837868613c3c720eb09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports